import React from "react";
import { Link} from 'react-router-dom';
import { connect } from "react-redux";
import { useEffect } from "react";
import {
  Card,
  CardText,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { isEmpty ,isUndefined, size } from "lodash";
import moment from 'moment';
import { postUserID, deleteDivorce} from "./landingPage.actions";
import  {getFilledStatus} from "../../src/views/user_views/accounts/account.actions";
import {getFormData} from "../../src/views/user_views/forms/profileInformation/profileInformation.actions";
import { useHistory } from "react-router-dom";
import Image from 'react-bootstrap/Image';
import { parseDate } from "../global/globalFunctions";


const LandingPage = (props) => {
  const redirect =(divorce_id) =>{
    window.localStorage.setItem("divorce_id", divorce_id);
  }
  
 
  function redirectToNewDivorce() {
   window.localStorage.setItem("divorce_id", "");
  }
  useEffect(() => {
    props.postUserID({ userId: window.localStorage.getItem("user_id") });
  }, []);
  return !props.isFetchingUsers ? (
    <div >
    <Image src="../adv.jpg" 
    style={{
        maxWidth: "100%",
        height : "90%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "filled",
        position: "relative",
        
      }}
    /> 
   
      <Container style={{ position: "absolute", top: "40px",marginLeft:"8%"}}>
        <Card
          style={{
            background: "rgba(255,255,255,.1)",
            boxShadow: "0 5px 15px rgba(0,0,0,.5)",
          }}
        >
          <Row>


            {!isEmpty(props.divorcesList) &&
              props.divorcesList.map((item, i) => (
                <Col lg={6} md={6} sm={6}>
                  <Card
                    style={{
                      color: "#d9f4f5",
                      marginTop: "8px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      backgroundColor: "#ff9933",
                      background: "rgba(102,205,170,.35)",
                      boxShadow: "0 5px 15px rgba(0,0,0,.5)",
                    }}
                  >
                    <CardBody>
                      <CardText tag="h6">
                        Petitioner : { isEmpty(item.petitioner) ? "" : item.petitioner}
                      </CardText>
                      <CardText tag="h6">
                        Respondant : { isEmpty(item.spouse_first_name) ? "" : item.spouse_first_name }
                      </CardText>
                      <CardText tag="h6">
                        Marriage Date : {parseDate(item.marriage_date)}
                      </CardText>
                      <Link to='/introduction'>
                      <Button
                        style={{
                          color: "white",
                          backgroundColor: "#1261A0",
                        }}
                        onClick={() => {
                          console.log(item,"itemmmmmmmmmmmmm")
                          props.getFilledStatus({
                            divorce_id: item.divorce_id,
                          });
                          props.getFormData({
                            divorce_id: item.divorce_id,
                          });
                           
                        redirect(item.divorce_id)

                        }}
                      >
                        Update
                      </Button>
                      </Link>
                      <Button
                        style={{
                          color: "white",
                          backgroundColor: "#1261A0",
                          margin: "0 10px",
                        }}
                        onClick={
                         () => props.deleteCurrentDivorcrce({divorce_id:  item.divorce_id})
                        }
                      >
                        Delete
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              ))}
          </Row>
{size(props.divorcesList) < 2 && 
          <div>
             <Link to='/introduction'>
            <Button
              color="primary"
              style={{
                width: "250px",
                height: "45px",
                marginTop: "8px",
                marginBottom: "8px",
                marginRight: "12px",
                float: "right",
                backgroundColor: "#00CED1",
                color: "#800000",
              }}
              onClick={() => {
                redirectToNewDivorce();
              }}
            >
              Start New Divorce
            </Button>
            </Link>
          </div>
}
        </Card>
      </Container>
    </div>
  ) : (
    <Spinner
      style={{ width: "3rem", height: "3rem", textAlign: "center" }}
      color="info"
      type="grow"
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  isFetchingUsers: state.LandingPageReducer.isFetchingUsersID,
  divorcesList: state.LandingPageReducer.divorcesList,
  isFilled: state.userAccountReducer.isFilled,
});

const mapDispatchToProps = (dispatch) => {
  return {
    postUserID: (data) => dispatch(postUserID(data)),
    deleteCurrentDivorcrce: (data) => dispatch(deleteDivorce(data)),
    getFormData: (data) => dispatch(getFormData(data)),
    getFilledStatus: (data) => dispatch(getFilledStatus(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
